import moment from 'moment';
import 'moment-duration-format';

export class DateUtils {
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  public static initialDate = new Date(2000, 0, 1, 0, 0, 0);

  public static secondsToTimespanJson(seconds: number | string): string {
    return (moment.duration(+seconds, 'seconds') as any).format('hh:mm:ss', { trim: false });
  }

  public static timespansToSecondsJson(timestamp: string): number {
    return moment.duration(timestamp).asSeconds();
  }

  public static durationFromDate(date: Date): number {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return (date.getDate() - 1) * 86400 + date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();
  }

  public static formatDuration(duration: number | string, format: string): string {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (<any>moment.duration(duration, 'second')).format(format, { trim: false });
  }

  public static formatDate(date: Date, format: string): string {
    const momentDate = moment(date);
    const hasDays = format.toLowerCase().includes('dd');
    if (hasDays) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      const days = (momentDate.date() - 1).toString().padStart(2, '0');
      return `${days}:${momentDate.format('HH:mm:ss')}`;
    }

    return momentDate.format(format);
  }

  public static getDurationFormat(duration: number): string {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return duration >= 86400 ? 'DD:HH:mm:ss' : 'HH:mm:ss';
  }

  public static dateFromDuration(duration: number): Date {
    return new Date(
      this.initialDate.getFullYear(),
      this.initialDate.getMonth(),
      this.initialDate.getDate(),
      this.initialDate.getHours(),
      this.initialDate.getMinutes(),
      duration,
    );
  }
}
